module.exports = __webpack_public_path__ + "img/Forum.7bc0b080.svg";